// 요약, the phone's first screen (design 02 9): this month's sums and
// spending against the budget, a big 빠른 입력 button, the latest rows.
import { useMemo, useState } from 'react'

import { Spinner } from '../../ui/common'
import { navigate } from '../../ui/router'
import { won } from '../format'
import { type ShownRow, sortRows } from '../model'
import { byCategory, rowsOfMonth } from '../views'
import { Bar, type Current, MonthSwitch } from './common'
import { QuickEntry, RowSheet } from './Entry'
import { MonthSums, RowLine } from './Rows'
import { CategoryBars } from './Views'

export function SummaryScreen({ cur, month, setMonth }: { cur: Current; month: string; setMonth: (m: string) => void }) {
  const [adding, setAdding] = useState(false)
  const [editing, setEditing] = useState<ShownRow | null>(null)
  const rows = useMemo(() => rowsOfMonth(cur.rows, month), [cur.rows, month])
  const items = cur.book?.items ?? {}
  const budgets = cur.book?.budgets ?? {}
  const cat = useMemo(() => byCategory(cur.rows, items, budgets, month), [cur.rows, items, budgets, month])
  const latest = useMemo(() => sortRows(rows).slice(0, 5), [rows])
  const open = editing ? (cur.rows.find((r) => r.client_id === editing.client_id) ?? null) : null

  return (
    <div className="page t-page">
      <MonthSwitch month={month} onChange={setMonth} />
      <section className="card t-summary" aria-label="이 달 요약">
        <MonthSums rows={rows} />
        {cat.budget > 0 && (
          <div className="t-budget-all">
            <div className="t-bar-head small">
              <span>예산 {won(cat.budget)}</span>
              <span className={cat.spent > cat.budget ? 'danger' : 'muted'}>
                {cat.spent > cat.budget ? `${won(cat.spent - cat.budget)} 넘음` : `${won(cat.budget - cat.spent)} 남음`}
              </span>
            </div>
            <Bar part={cat.spent} whole={cat.budget} label="예산 대비 지출" />
          </div>
        )}
      </section>
      <button type="button" className="primary t-quick" onClick={() => setAdding(true)}>
        빠른 입력
      </button>
      {cur.book?.loading && cur.rows.length === 0 ? (
        <Spinner />
      ) : (
        <>
          <section className="card">
            <h3>분류별 지출</h3>
            <CategoryBars view={cat} />
            <button type="button" className="link" onClick={() => navigate('/budgets')}>
              예산 정하기
            </button>
          </section>
          {latest.length > 0 && (
            <section className="card">
              <h3>최근 거래</h3>
              <ul className="list">
                {latest.map((r) => (
                  <RowLine key={r.client_id} cur={cur} row={r} onOpen={setEditing} />
                ))}
              </ul>
              <button type="button" className="link" onClick={() => navigate('/rows')}>
                거래 모두 보기
              </button>
            </section>
          )}
        </>
      )}
      <QuickEntry cur={cur} open={adding} onClose={() => setAdding(false)} />
      <RowSheet cur={cur} row={open} onClose={() => setEditing(null)} />
    </div>
  )
}
